// editar/EditarTalonario.js
import React, { useState } from 'react';
import { 
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  Button, 
  TextField, 
  Grid,
  CircularProgress,
  Alert
} from '@mui/material';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

const EditarTalonario = ({ open, onClose, talonario }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [formData, setFormData] = useState({
    username: talonario?.username || '',
    pto_venta: talonario?.pto_venta || '',
    numero_desde: talonario?.numero_desde || '',
    numero_hasta: talonario?.numero_hasta || '',
    fecha_asignado: talonario?.fecha_asignado 
      ? new Date(talonario.fecha_asignado).toISOString().slice(0, 16)
      : ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    setError('');
  };

  const handleSubmit = async () => {
    // Validaciones
    if (!formData.username) {
      setError('Ingresa un usuario');
      return;
    }
    if (!formData.pto_venta) {
      setError('Ingresa un punto de venta');
      return;
    }
    if (!formData.numero_desde || !formData.numero_hasta) {
      setError('Ingresa los números desde y hasta');
      return;
    }
    if (parseInt(formData.numero_desde) > parseInt(formData.numero_hasta)) {
      setError('El número "desde" debe ser menor que el "hasta"');
      return;
    }

    setLoading(true);
    setError('');
    try {
      const response = await fetch(`${API_URL}/envasado_talonarios/${talonario.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData)
      });
      
      if (!response.ok) {
        throw new Error(`Error ${response.status}: ${response.statusText}`);
      }
      
      onClose(true);
    } catch (error) {
      console.error('Error al editar talonario:', error);
      setError(error.message || 'Error al editar el talonario');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={open} onClose={() => onClose(false)} maxWidth="md" fullWidth>
      <DialogTitle>Editar Talonario #{talonario?.id}</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Usuario"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Punto de Venta"
              name="pto_venta"
              value={formData.pto_venta}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Número Desde"
              name="numero_desde"
              type="number"
              value={formData.numero_desde}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Número Hasta"
              name="numero_hasta"
              type="number"
              value={formData.numero_hasta}
              onChange={handleChange}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Fecha Asignación"
              name="fecha_asignado"
              type="datetime-local"
              value={formData.fecha_asignado}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              required
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onClose(false)} disabled={loading}>
          Cancelar
        </Button>
        <Button 
          onClick={handleSubmit} 
          variant="contained" 
          color="primary"
          disabled={loading}
        >
          {loading ? <CircularProgress size={24} /> : 'Guardar'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditarTalonario;